import { Stack, Checkbox } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { MapComponent } from "../../../project/stores/MapStore";
import { useStores } from "../../../shared/stores/RootStore";
import { t } from "i18next";

const MapComponentVisibilityControlsBase = ({
  components,
}: {
  components: MapComponent[];
}) => {
  const { mapStore } = useStores();

  return (
    <Stack>
      {components.map((component) => (
        <Checkbox.Root
          pointerEvents="all"
          colorPalette="primary"
          key={component}
          checked={mapStore.componentVisibility[component]}
          onChange={() =>
            mapStore.setComponentVisibility((prev) => ({
              ...prev,
              [component]: !prev[component],
            }))
          }
        >
          <Checkbox.HiddenInput />
          <Checkbox.Control />
          <Checkbox.Label>{t(`map:component.${component}`)}</Checkbox.Label>
        </Checkbox.Root>
      ))}
    </Stack>
  );
};

export const MapComponentVisibilityControls = observer(
  MapComponentVisibilityControlsBase,
);
